'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Button } from '@components/ui/button';
import { COLORS } from './game/constants';
function handleReload() {
  window.location.reload();
}
export function StaticFallback() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-secondary-500 text-sm font-medium"><span>404</span><span className="mx-2">·</span><span>Page not found</span></p>;
    t1 = <h1 className="font-ivar text-secondary-900 max-w-2xl text-4xl leading-tight md:text-5xl lg:text-[56px]">We can't find the page you're looking for</h1>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-white px-6 py-12" data-sentry-component="StaticFallback" data-sentry-source-file="static-fallback.tsx"><div className="flex flex-col items-center gap-6 text-center">{t0}{t1}<div className="mt-2 flex flex-col items-center gap-3"><Button variant="primary" size="lg-alt" asChild={true} data-sentry-element="Button" data-sentry-source-file="static-fallback.tsx"><Link href="/" data-sentry-element="Link" data-sentry-source-file="static-fallback.tsx">Go to Home</Link></Button><button type="button" onClick={handleReload} className="text-secondary-500 text-sm underline-offset-4 hover:underline">Reload page</button></div></div><StaticDocPile data-sentry-element="StaticDocPile" data-sentry-source-file="static-fallback.tsx" /></main>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
const DOC_POSITIONS = [{
  x: 40,
  y: 70,
  r: -12
}, {
  x: 160,
  y: 50,
  r: 6
}, {
  x: 260,
  y: 80,
  r: -4
}, {
  x: 360,
  y: 40,
  r: 10
}, {
  x: 440,
  y: 75,
  r: -8
}, {
  x: 540,
  y: 55,
  r: 3
}, {
  x: 620,
  y: 85,
  r: -15
}, {
  x: 90,
  y: 120,
  r: 8
}];
function StaticDocPile() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg aria-hidden="true" className="pointer-events-none absolute bottom-0 left-1/2 h-48 w-[720px] max-w-full -translate-x-1/2 opacity-70" viewBox="0 0 720 200" data-sentry-element="svg" data-sentry-component="StaticDocPile" data-sentry-source-file="static-fallback.tsx">{DOC_POSITIONS.map(_temp)}</svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(doc, i) {
  return <g key={i} transform={`translate(${doc.x}, ${doc.y}) rotate(${doc.r})`}><rect x={-40} y={-50} width={80} height={100} rx={10} fill={COLORS.docFill} stroke={COLORS.docStroke} /><rect x={-28} y={-32} width={52} height={4} rx={2} fill={COLORS.docBars} /><rect x={-28} y={-20} width={44} height={4} rx={2} fill={COLORS.docBars} /><rect x={-28} y={-8} width={48} height={4} rx={2} fill={COLORS.docBars} /><rect x={-28} y={4} width={36} height={4} rx={2} fill={COLORS.docBars} /></g>;
}